import { config as env } from "@/config";

export const config = {
  projectKey: env.NEXT_PUBLIC_CT_PROJECT_KEY,
  apiHost: env.NEXT_PUBLIC_CT_API_URL,
  authHost: env.NEXT_PUBLIC_CT_AUTH_URL,
};
